import { useUserStore } from '~/stores/auth';
import { DEBUG, GLOBAL_MESSAGE_EVENT, type PayloadDataType } from './index';
import { useTeamsStore } from '~/stores/teams';

type CreateTeam = {
  eventType: 'create-team';
  teamId: number;
  teamName: string;
  channelId: number;
  userName: string;
  userId: number;
};

type MappedData = {
  teamId: string | number;
  eventType: 'CREATE' | 'UPDATE';
};

const contextUser = (userId: number) => {
  const piniaUser = useUserStore();
  const ctxId = piniaUser.user as unknown as {
    summary: { basicUserInfo: { userId: number } };
  };
  return ctxId.summary.basicUserInfo.userId === userId;
};

/**
 * Handles the CREATE_TEAM pubsub event.
 *
 *
 * SIDE EFFECTS: Fetches and caches member and emits a global message.
 *
 * @param {PayloadDataType} PayloadDataType - Team member data
 *
 * @returns {Promise<void>}
 */
export async function handleCreateTeam(
  ...[_channel, data]: PayloadDataType<CreateTeam>
) {
  if (DEBUG) console.log('handlePusherMessages', data);
  const piniaTeams = useTeamsStore();
  const emitter = useNuxtApp().$emitter;

  const mappedData: MappedData = {
    teamId: data.teamId,
    eventType: data.eventType.toUpperCase() as 'CREATE' | 'UPDATE',
  };
  await piniaTeams.mutateTeamsTable({
    channelId: data.channelId,
    mappedData,
  });
  if (contextUser(data.userId)) {
    piniaTeams.supressToastMessageForTeam(true);
    emitter.$emit(GLOBAL_MESSAGE_EVENT, {
      message: 'New team has been added to channel.',
      status: 200,
    });
    setTimeout(() => {
      piniaTeams.supressToastMessageForTeam(false);
    }, 1000);
  }
  emitter.$emit('update-all-teams');
}
